import { render, staticRenderFns } from "./SourceItem.vue?vue&type=template&id=4c481524&scoped=true&"
import script from "./SourceItem.vue?vue&type=script&lang=js&"
export * from "./SourceItem.vue?vue&type=script&lang=js&"
import style0 from "./SourceItem.vue?vue&type=style&index=0&id=4c481524&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c481524",
  null
  
)

export default component.exports